import { useEffect, useState } from 'react'

import { Spinner } from '@/components/ui/spinner'
import { cn } from '@/lib/utils'

export function StepTicker({
  steps,
  step,
  startedAt,
}: {
  steps: string[]
  step: number
  startedAt?: number
}) {
  const [now, setNow] = useState(Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 250)
    return () => clearInterval(id)
  }, [])
  const elapsed = startedAt ? ((now - startedAt) / 1000).toFixed(1) : '0.0'
  return (
    <div
      role="status"
      className="flex items-center gap-3 rounded-md border border-border bg-muted/40 px-3 py-2 text-xs"
    >
      <Spinner className="size-3.5" />
      <ol className="flex flex-wrap gap-x-3">
        {steps.map((s, i) => (
          <li
            key={s}
            className={cn(
              i < step && 'text-muted-foreground line-through',
              i === step && 'font-medium text-primary',
              i > step && 'text-muted-foreground',
            )}
          >
            {s}
          </li>
        ))}
      </ol>
      <span className="ml-auto font-mono tabular-nums text-muted-foreground">{elapsed}s</span>
    </div>
  )
}
